export interface CityOption {
  id: string;
  name: string;
  country: string;
  aliases?: string[];
}

const city = (name: string, country: string, aliases?: string[]): CityOption => ({
  id: `${name}-${country}`
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, ""),
  name,
  country,
  aliases,
});

export const CITIES: CityOption[] = [
  city("Hanoi", "Vietnam", ["Ha Noi"]),
  city("Ho Chi Minh City", "Vietnam", ["Saigon", "HCMC"]),
  city("Da Nang", "Vietnam"),
  city("Hue", "Vietnam", ["Huế"]),
  city("Can Tho", "Vietnam", ["Cần Thơ"]),
  city("Hai Phong", "Vietnam", ["Hải Phòng"]),
  city("Nha Trang", "Vietnam"),
  city("Da Lat", "Vietnam", ["Dalat"]),
  city("Hoi An", "Vietnam", ["Hội An"]),
  city("Vung Tau", "Vietnam", ["Vũng Tàu"]),
  city("Singapore", "Singapore"),
  city("Bangkok", "Thailand"),
  city("Chiang Mai", "Thailand"),
  city("Phuket", "Thailand"),
  city("Kuala Lumpur", "Malaysia", ["KL"]),
  city("George Town", "Malaysia", ["Penang"]),
  city("Johor Bahru", "Malaysia", ["JB"]),
  city("Jakarta", "Indonesia"),
  city("Denpasar", "Indonesia", ["Bali"]),
  city("Yogyakarta", "Indonesia", ["Jogja"]),
  city("Surabaya", "Indonesia"),
  city("Manila", "Philippines"),
  city("Cebu City", "Philippines", ["Cebu"]),
  city("Davao City", "Philippines", ["Davao"]),
  city("Phnom Penh", "Cambodia"),
  city("Siem Reap", "Cambodia"),
  city("Vientiane", "Laos"),
  city("Luang Prabang", "Laos"),
  city("Yangon", "Myanmar", ["Rangoon"]),
  city("Tokyo", "Japan"),
  city("Kyoto", "Japan"),
  city("Osaka", "Japan"),
  city("Sapporo", "Japan"),
  city("Fukuoka", "Japan"),
  city("Naha", "Japan", ["Okinawa"]),
  city("Seoul", "South Korea"),
  city("Busan", "South Korea"),
  city("Jeju City", "South Korea", ["Jeju"]),
  city("Beijing", "China", ["Peking"]),
  city("Shanghai", "China"),
  city("Guangzhou", "China", ["Canton"]),
  city("Shenzhen", "China"),
  city("Chengdu", "China"),
  city("Xi'an", "China", ["Xian"]),
  city("Hong Kong", "Hong Kong"),
  city("Macau", "Macau", ["Macao"]),
  city("Taipei", "Taiwan"),
  city("Kaohsiung", "Taiwan"),
  city("Ulaanbaatar", "Mongolia"),
  city("New Delhi", "India", ["Delhi"]),
  city("Mumbai", "India", ["Bombay"]),
  city("Bengaluru", "India", ["Bangalore"]),
  city("Kolkata", "India", ["Calcutta"]),
  city("Chennai", "India", ["Madras"]),
  city("Hyderabad", "India"),
  city("Jaipur", "India"),
  city("Kathmandu", "Nepal"),
  city("Colombo", "Sri Lanka"),
  city("Dhaka", "Bangladesh"),
  city("Karachi", "Pakistan"),
  city("Islamabad", "Pakistan"),
  city("Thimphu", "Bhutan"),
  city("Malé", "Maldives", ["Male"]),
  city("London", "United Kingdom"),
  city("Edinburgh", "United Kingdom"),
  city("Manchester", "United Kingdom"),
  city("Dublin", "Ireland"),
  city("Paris", "France"),
  city("Lyon", "France"),
  city("Nice", "France"),
  city("Amsterdam", "Netherlands"),
  city("Rotterdam", "Netherlands"),
  city("Brussels", "Belgium"),
  city("Berlin", "Germany"),
  city("Munich", "Germany", ["München"]),
  city("Hamburg", "Germany"),
  city("Frankfurt", "Germany"),
  city("Zurich", "Switzerland", ["Zürich"]),
  city("Geneva", "Switzerland", ["Genève"]),
  city("Vienna", "Austria", ["Wien"]),
  city("Prague", "Czechia", ["Praha"]),
  city("Warsaw", "Poland", ["Warszawa"]),
  city("Kraków", "Poland", ["Krakow"]),
  city("Budapest", "Hungary"),
  city("Copenhagen", "Denmark", ["København"]),
  city("Stockholm", "Sweden"),
  city("Oslo", "Norway"),
  city("Helsinki", "Finland"),
  city("Reykjavík", "Iceland", ["Reykjavik"]),
  city("Lisbon", "Portugal", ["Lisboa"]),
  city("Porto", "Portugal"),
  city("Madrid", "Spain"),
  city("Barcelona", "Spain"),
  city("Seville", "Spain", ["Sevilla"]),
  city("Rome", "Italy", ["Roma"]),
  city("Milan", "Italy", ["Milano"]),
  city("Florence", "Italy", ["Firenze"]),
  city("Venice", "Italy", ["Venezia"]),
  city("Athens", "Greece"),
  city("Istanbul", "Türkiye", ["Turkey"]),
  city("Bucharest", "Romania", ["București"]),
  city("Sofia", "Bulgaria"),
  city("Zagreb", "Croatia"),
  city("Split", "Croatia"),
  city("Ljubljana", "Slovenia"),
  city("Belgrade", "Serbia", ["Beograd"]),
  city("Sarajevo", "Bosnia and Herzegovina"),
  city("Tallinn", "Estonia"),
  city("Riga", "Latvia"),
  city("Vilnius", "Lithuania"),
  city("Kyiv", "Ukraine", ["Kiev"]),
  city("Tbilisi", "Georgia"),
  city("Yerevan", "Armenia"),
  city("Dubai", "United Arab Emirates", ["UAE"]),
  city("Abu Dhabi", "United Arab Emirates", ["UAE"]),
  city("Doha", "Qatar"),
  city("Riyadh", "Saudi Arabia"),
  city("Jeddah", "Saudi Arabia"),
  city("Muscat", "Oman"),
  city("Amman", "Jordan"),
  city("Beirut", "Lebanon"),
  city("Tel Aviv", "Israel"),
  city("Jerusalem", "Israel"),
  city("Cairo", "Egypt"),
  city("Marrakesh", "Morocco", ["Marrakech"]),
  city("Casablanca", "Morocco"),
  city("Tunis", "Tunisia"),
  city("Cape Town", "South Africa"),
  city("Johannesburg", "South Africa"),
  city("Nairobi", "Kenya"),
  city("Addis Ababa", "Ethiopia"),
  city("Accra", "Ghana"),
  city("Lagos", "Nigeria"),
  city("Kigali", "Rwanda"),
  city("New York", "United States", ["New York City", "NYC"]),
  city("Los Angeles", "United States", ["LA"]),
  city("San Francisco", "United States", ["SF"]),
  city("Seattle", "United States"),
  city("Chicago", "United States"),
  city("Boston", "United States"),
  city("Washington", "United States", ["Washington DC", "D.C."]),
  city("Miami", "United States"),
  city("Austin", "United States"),
  city("New Orleans", "United States"),
  city("Honolulu", "United States", ["Hawaii"]),
  city("Vancouver", "Canada"),
  city("Toronto", "Canada"),
  city("Montréal", "Canada", ["Montreal"]),
  city("Québec City", "Canada", ["Quebec City"]),
  city("Calgary", "Canada"),
  city("Mexico City", "Mexico", ["Ciudad de México", "CDMX"]),
  city("Cancún", "Mexico", ["Cancun"]),
  city("Havana", "Cuba", ["La Habana"]),
  city("San José", "Costa Rica", ["San Jose"]),
  city("Panama City", "Panama", ["Ciudad de Panamá"]),
  city("San Juan", "Puerto Rico"),
  city("Bogotá", "Colombia", ["Bogota"]),
  city("Medellín", "Colombia", ["Medellin"]),
  city("Quito", "Ecuador"),
  city("Lima", "Peru"),
  city("Cusco", "Peru", ["Cuzco"]),
  city("La Paz", "Bolivia"),
  city("Santiago", "Chile"),
  city("Buenos Aires", "Argentina"),
  city("Montevideo", "Uruguay"),
  city("São Paulo", "Brazil", ["Sao Paulo"]),
  city("Rio de Janeiro", "Brazil", ["Rio"]),
  city("Brasília", "Brazil", ["Brasilia"]),
  city("Sydney", "Australia"),
  city("Melbourne", "Australia"),
  city("Brisbane", "Australia"),
  city("Perth", "Australia"),
  city("Adelaide", "Australia"),
  city("Auckland", "New Zealand"),
  city("Wellington", "New Zealand"),
  city("Queenstown", "New Zealand"),
  city("Suva", "Fiji"),
];

export function normalizeCityText(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

export function formatCity(option: CityOption): string {
  return option.name === option.country ? option.name : `${option.name}, ${option.country}`;
}

export function findCities(query: string, limit = CITIES.length): CityOption[] {
  const safeLimit = Math.max(0, Math.min(CITIES.length, Math.floor(limit)));
  if (safeLimit === 0) return [];

  const normalizedQuery = normalizeCityText(query);
  if (!normalizedQuery) {
    return CITIES.slice(0, safeLimit);
  }

  return CITIES.map((option) => {
    const terms = [option.name, option.country, ...(option.aliases ?? [])].map(normalizeCityText);
    const combined = terms.join(" ");
    let score = Number.POSITIVE_INFINITY;

    if (terms.some((term) => term === normalizedQuery)) score = 0;
    else if (terms.some((term) => term.startsWith(normalizedQuery))) score = 1;
    else if (combined.split(" ").some((word) => word.startsWith(normalizedQuery))) score = 2;
    else if (combined.includes(normalizedQuery)) score = 3;

    return { option, score };
  })
    .filter(({ score }) => Number.isFinite(score))
    .sort((left, right) => left.score - right.score || left.option.name.localeCompare(right.option.name))
    .slice(0, safeLimit)
    .map(({ option }) => option);
}
